import useGetDiagnosis from '@/legacy-src/components/recommendedTherapist/hooks/useGetDiagnosis'
import useTherapists from '@/legacy-src/hooks/useTherapists'
import { type TherapistType } from '@/legacy-src/types/TherapistStateType'

const useGetMatchingTherapist = (therapistId: number) => {
  const { data } = useGetDiagnosis()
  const { therapists } = useTherapists('visible')

  const matchingTherapistData = data?.therapistMatches?.find((therapist) => therapist.therapistId === therapistId)
  const matchingTherapist = therapists?.find((item: TherapistType) => item.therapistId === therapistId)

  return { matchingTherapistData, matchingTherapist, data }
}

export default useGetMatchingTherapist
